<template>
    <div class="p-4">
        <!-- <h3 class="font-normal text-xl py-3 mb-3 border-info pl-3" style="margin-left: -1em; border-left: 6px solid;"> -->
        <h3 class="note-header">
            {{ title }}
        </h3>

        <pre class="note-body">
            {{ body }}
        </pre>

    </div>
</template>

<script>
    export default {
        props: ['title', 'body'],

        methods: {
            beforeOpen(event) {
                console.log("In before open")
            }
        }
    }
</script>
